module.exports = __webpack_public_path__ + "static/media/logo512.bd34e312.png";